import React from "react";
import { Badge, IconButton, TableCell, Tooltip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getIconByEstadoDocumental, respaldosPendientesBadge } from "../ListadoSolicitud.iconMaps";

// Columna "Documental": ícono según idEstadoVerificacionDocumental, con caso
// especial cuando es firma Yupana en Estado 6 sin firma electrónica aún.
export default function CeldaDocumental({
  data,
  isError,
  estaDeshabilitado,
  estadoDeshabilitadoDocumental,
  verificacionSolicitud,
  handledocumentos,
  handlePopoverOpen,
}) {
  const esFirmaElectronica = Number(data.TipoFirmaElectronica) === 1;
  const esCasoEspecialFirma =
    esFirmaElectronica &&
    Number(data.Estado) === 6 &&
    Number(data.idFirmaElectronica) === 0;
  // TipoFirmaElectronica=1 pero Estado != 6 → no mostrar el botón documental
  const ocultarBotonDocumental = esFirmaElectronica && Number(data.Estado) !== 6;

  // Distintivo por ciclo activo de RespaldosPendientesWeb (1=pendiente de carga, 2=enviado a revisar).
  // Se muestra siempre en la esquina superior derecha del ícono Documental, sin importar su estado/color.
  const infoRespaldosPendientes = respaldosPendientesBadge[data.RespaldosPendientesEstado];

  return (
    <TableCell align="center">
      <div>
        <span>
          {!ocultarBotonDocumental && (
          <Tooltip title={infoRespaldosPendientes ? infoRespaldosPendientes.tooltip : ""}>
            <Badge
              variant="dot"
              invisible={!infoRespaldosPendientes}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: infoRespaldosPendientes?.color,
                  boxShadow: "0 0 0 1.5px white",
                },
              }}
            >
              <IconButton
                onClick={() => handledocumentos(data)}
                disabled={
                  esCasoEspecialFirma
                    ? false
                    : estaDeshabilitado(data) ||
                      estadoDeshabilitadoDocumental(data) ||
                      verificacionSolicitud(data)
                }
                size="small"
                sx={{
                  opacity: estaDeshabilitado(data) ? 0.4 : 1,
                  bgcolor: isError ? "#fee2e2" : "#f1f5f9",
                  "&:hover": {
                    bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                    transform: "scale(1.1)",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {esCasoEspecialFirma ? (
                  <CheckCircleIcon sx={{ color: "rgb(56, 142, 60)" }} />
                ) : (
                  getIconByEstadoDocumental(data.idEstadoVerificacionDocumental)
                )}
              </IconButton>
            </Badge>
          </Tooltip>
          )}

          {/* InfoIcon al lado del IconButton */}
          <span
            style={{
              // pointerEvents: estaDeshabilitado(data)
              //   ? "none"
              //   : "auto",
              // opacity: estaDeshabilitado(data) ? 0.5 : 1,
            }}
          >
            <MoreVertIcon
              onClick={(event) =>
                handlePopoverOpen(event, 3, data)
              }
              style={{ cursor: "pointer" }}
              className="text-slate-400 hover:text-slate-600 transition-colors duration-200"
            />
          </span>
        </span>

      </div>
    </TableCell>
  );
}
